(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dotique-customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dotique-customer-stories')) {
    customElements.define('dotique-customer-stories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dotique-stories__track');
        this.items = Array.from(this.querySelectorAll('.dotique-stories__item'));
        this.previous = this.querySelector('.dotique-stories__previous');
        this.next = this.querySelector('.dotique-stories__next');
        this.counter = this.querySelector('[data-current]');
        if (!this.track || !this.items.length) return;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.track.addEventListener('scroll', this.queueUpdate, { passive: true, ...options });
        this.previous?.addEventListener('click', () => this.go(this.index - 1), options);
        this.next?.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || this.desktop.matches) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? direction : -direction));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.items.length - 1);
          }
        }, options);
        this.track.addEventListener('focusin', (event) => {
          const item = event.target.closest('.dotique-stories__item');
          if (item && !this.desktop.matches) this.go(this.items.indexOf(item), 'auto');
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex(item => item.dataset.storyId === event.detail.blockId);
          if (index >= 0) this.go(index, 'auto');
        }, options);
        this.desktop.addEventListener('change', this.queueUpdate, options);
        this.observer = new ResizeObserver(this.queueUpdate);
        this.items.forEach(item => this.observer.observe(item));
        this.setAttribute('data-ready', '');
        this.update();
      }
      update() {
        if (this.desktop.matches) {
          this.track.style.removeProperty('block-size');
          this.track.tabIndex = -1;
          return;
        }
        this.track.tabIndex = 0;
        const bounds = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? bounds.right : bounds.left;
        let nearest = Infinity;
        this.items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs((rtl ? rect.right : rect.left) - edge);
          if (distance < nearest) { nearest = distance; this.index = index; }
        });
        const height = Math.ceil(this.items[this.index].getBoundingClientRect().height);
        if (height > 0 && this.track.style.blockSize !== height + 'px') this.track.style.blockSize = height + 'px';
        if (this.counter) this.counter.textContent = String(this.index + 1);
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.items.length - 1;
      }
      go(index, behavior) {
        if (this.desktop.matches) return;
        const target = this.items[Math.max(0, Math.min(index, this.items.length - 1))];
        const bounds = this.track.getBoundingClientRect();
        const targetBounds = target.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const delta = rtl ? targetBounds.right - bounds.right : targetBounds.left - bounds.left;
        this.track.scrollBy({ left: delta, behavior: behavior || (this.motion.matches ? 'auto' : 'smooth') });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
